// extracted by mini-css-extract-plugin
module.exports = {"root":"Compact_root__BfZRr","disabled":"Compact_disabled__vcUsj","loading":"Compact_loading___mfmL","completed":"Compact_completed__akj_e","waiting":"Compact_waiting__1NXlP"};